import React from "react";
import { formatScore, ordinalValue } from "../lib/helpers";
import ImageWithFallback from "./ImageWithFallback";
import { PlayerImage } from "./PlayerImage";
import Image from "next/image";

const ScoreSummaryPlayers = (props) => {
  const players = props.players;

  return (
    <React.Fragment>
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden ring-1 ring-black ring-opacity-5">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-black ">
              <tr>
                <th
                  scope="col"
                  className="p-2 pr-3 text-left text-[14px] font-bold shadow-lg text-white"
                >
                  Player
                </th>
                <th />
                <th
                  scope="col"
                  className="p-2 px-3 text-[14px] font-bold shadow-lg text-white text-right hidden sm:table-cell"
                >
                  Position
                </th>
                <th
                  scope="col"
                  className="p-2 px-3 text-[14px] font-bold shadow-lg text-white text-right hidden lg:table-cell"
                >
                  Hole
                </th>
                <th
                  scope="col"
                  className="p-2 px-3 text-[14px] font-bold shadow-lg text-white text-right"
                >
                  Score
                </th>
                <th
                  scope="col"
                  className="p-2 px-3 text-[14px] font-bold shadow-lg text-white text-right"
                >
                  Given
                </th>
              </tr>
            </thead>
            <tbody className="divide-gray-200 bg-white">
              {players &&
                players.map((player) => {
                  const playerFirstName: string = player?.first_name;
                  const playerLastName: string = player?.last_name;
                  const playerStatus = player.ScoreDetails?.Totals?.status;
                  const playerPositionOrd = ordinalValue(
                    player.ScoreDetails?.Totals?.position,
                  );
                  const playerPosition = (
                    <span>
                      {player.ScoreDetails?.Totals?.position}
                      <sup>{playerPositionOrd}</sup>
                    </span>
                  );
                  const playerCutOrWithdrawn = playerStatus === ("cut" || "wd");
                  return (
                    <tr
                      key={player.id}
                      className={`${playerStatus === "cut" && "bg-red-100"}`}
                    >
                      <td>
                        <div className="mr-2">
                          <Image
                            alt={`${playerFirstName} ${playerLastName}`}
                            src={
                              player.image ||
                              "https://stgolfchampsprodeastus.blob.core.windows.net/public/not_found.png"
                            }
                            width={50}
                            height={50}
                            className={"object-fit rounded"}
                            unoptimized
                          />
                        </div>
                      </td>
                      <td className="font-serif pr-3 font-medium text-[14px] text-gray-900">
                        <span className="">
                          {player.first_name} {player.last_name}
                        </span>
                      </td>
                      <td
                        className={`${
                          playerCutOrWithdrawn && "text-red-800 text-bold"
                        } whitespace-nowrap font-serif px-3 py-2 text-gray-500 text-right hidden sm:table-cell text-[14px]`}
                      >
                        {(playerCutOrWithdrawn
                          ? playerStatus.toUpperCase()
                          : player.ScoreDetails && playerPosition) || "-"}
                      </td>
                      <td className="whitespace-nowrap font-serif px-3 py-2 text-gray-500 text-right hidden lg:table-cell text-[14px]">
                        {(player.ScoreDetails &&
                          player.ScoreDetails?.Totals?.holesPlayed) ||
                          "-"}
                      </td>
                      <td className="whitespace-nowrap font-serif px-3 py-2 text-gray-500 text-right text-[14px]">
                        {(player.ScoreDetails &&
                          formatScore(
                            player.ScoreDetails?.Totals?.totalToPar,
                          )) ||
                          "-"}
                      </td>
                      <td className="whitespace-nowrap font-serif px-3 py-2 text-gray-500 text-right text-[14px]">
                        {(player.ScoreDetails &&
                          formatScore(
                            player.ScoreDetails?.Totals?.givenScore,
                          )) ||
                          "-"}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScoreSummaryPlayers;
